import { render } from "./UserTasks.vue?vue&type=template&id=055929f4&scoped=true"
import script from "./UserTasks.vue?vue&type=script&lang=js"
export * from "./UserTasks.vue?vue&type=script&lang=js"

import "./UserTasks.vue?vue&type=style&index=0&id=055929f4&scoped=true&lang=scss"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055929f4"]])

export default __exports__